import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { NPS_SURVEY, EXTRA_SLOTS } from '@tfa/shared'
import { useAuth } from '../../hooks/useAuth'
import { api } from '../../services/api'
import { SurveyFlowSheet } from './SurveyFlowSheet'
import { surveyDraftKey } from '../../utils/surveyDraft'

interface Props {
  open: boolean
  onClose: () => void
  curator?: { name?: string | null; avatarUrl?: string | null } | null
}

function gz(gender: string | null | undefined, male: string, female: string): string {
  return gender === 'FEMALE' ? female : male
}

/**
 * Финальная анкета завершения (неделя 12) — #PRD. Тонкая обёртка над
 * SurveyFlowSheet: festive-интро по полу → оценки + 19 рефлексивных вопросов →
 * благодарность (+10 TuCoin + неделя подписки) + «Хочу на вторую ступень».
 */
export function NpsSurveySheet({ open, onClose, curator }: Props) {
  const qc = useQueryClient()
  const { user } = useAuth()
  const firstName = (user as { firstName?: string } | undefined)?.firstName || 'друг'
  const gender = (user as { gender?: string | null } | undefined)?.gender ?? null

  return (
    <SurveyFlowSheet
      open={open}
      onClose={onClose}
      accent="#F59E0B"
      curator={curator}
      questions={NPS_SURVEY}
      reward={EXTRA_SLOTS.NPS.tucoin}
      rewardExtra="+ 1 неделя подписки"
      introTimeLabel="≈ 15 минут"
      introTitle={`${firstName}, программа ТФА подходит к концу!`}
      introBody={`Ты ${gz(gender, 'проделал', 'проделала')} большую работу — мы гордимся тобой! Давай зафиксируем результаты и проведём рефлексию о пройденном пути.`}
      outroTitle={`${firstName}, твоя анкета принята!`}
      outroBody="Спасибо за обратную связь и работу. Увидимся в следующей ступени ТФА :) Дневником можешь пользоваться без ограничений."
      ctaLabel="Готово"
      draftKey={user?.id ? surveyDraftKey('NPS', user.id) : undefined}
      secondaryCta={{
        label: 'Хочу на вторую ступень',
        onClick: () => {
          api.submitNextStageInterest().catch(() => {})
          toast.success('Передали запрос куратору — скоро свяжутся!')
          onClose()
        },
      }}
      submit={async (answers) => {
        await api.submitNps(answers)
        qc.invalidateQueries({ queryKey: ['surveyStatus'] })
        qc.invalidateQueries({ queryKey: ['dashboard'] })
      }}
    />
  )
}
